// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__18vEw","alert":"SettungsInbox_alert__D8L9r"};